import IAppLogger from '@app/lib/IAppLogger';
import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import { DevicesReadyPayload } from '@modules/SoftPhoneModule/types';
import { webPhoneEventNames } from '@modules/SoftPhoneModule/constants/events';

/**
 * Handles the `webphone:devices-ready` event emitted by the webphone MFE
 * when audio devices have been enumerated and are ready for use.
 *
 * Populates the available device lists and active device IDs in
 * {@link audioDevicesState} and marks devices as ready.
 */
const handleDevicesReady = (
  payload: DevicesReadyPayload,
  logger: IAppLogger,
): void => {
  const {
    audioInputDevices,
    audioOutputDevices,
    activeAudioInputDeviceId,
    activeAudioOutputDeviceId,
    activeRingOutputDeviceId,
    microphoneAnalyser,
  } = payload;

  logger.debug(webPhoneEventNames.devicesReady, {
    activeAudioInputDeviceId,
    activeAudioOutputDeviceId,
    activeRingOutputDeviceId,
  });

  audioDevicesState.audioInputDevices = [...audioInputDevices];
  audioDevicesState.audioOutputDevices = [...audioOutputDevices];
  audioDevicesState.currentInputDeviceId = activeAudioInputDeviceId;
  audioDevicesState.currentOutputDeviceId = activeAudioOutputDeviceId;
  audioDevicesState.currentRingDeviceId = activeRingOutputDeviceId;
  audioDevicesState.microphoneAnalyser = microphoneAnalyser ?? null;
  audioDevicesState.isDevicesReady = true;
  audioDevicesState.errorCategory = null;
};

export default handleDevicesReady;
